module.exports = __webpack_public_path__ + "img/symbol_0.42d38d9e.png";